import React from 'react';
import './LikeButton.css';

/**
 * Reusable Like Button Component
 * Displays a heart icon with like count
 *
 * @param {Object} props
 * @param {boolean} props.isLiked - Whether the content is liked
 * @param {number} props.likeCount - Number of likes
 * @param {Function} props.onToggle - Callback when like is toggled
 * @param {boolean} props.disabled - Whether button is disabled
 * @param {string} props.size - 'small' | 'medium' | 'large'
 * @param {string} props.variant - 'default' | 'outline' | 'minimal'
 * @param {string} props.className - Additional CSS classes
 */
const LikeButton = ({
  isLiked = false,
  likeCount = 0,
  onToggle,
  disabled = false,
  size = 'small',
  variant = 'minimal',
  className = '',
}) => {
  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!disabled && onToggle) {
      onToggle();
    }
  };

  return (
    <button
      className={`like-button like-button--${size} like-button--${variant} ${isLiked ? 'liked' : ''} ${className}`}
      onClick={handleClick}
      disabled={disabled}
      title={isLiked ? 'Unlike' : 'Like'}
      aria-label={isLiked ? 'Unlike' : 'Like'}
    >
      <i className={`bi ${isLiked ? 'bi-heart-fill' : 'bi-heart'}`}></i>
      {likeCount > 0 && <span className="like-count">{likeCount}</span>}
    </button>
  );
};

export default LikeButton;
